import { AuthUser } from '../../../server/dto/AuthUser';


import { Users } from '../../../server/dto/generated/Users';


import { GeneratedBizBase } from '../../../framework/frontend/GeneratedBizBase';


import { Response } from '../../../framework/biz/Response';


import { OAuthResultUser } from '../../../server/dto/OAuthResultUser';


import { OAuthResult } from '../../../server/dto/OAuthResult';


 // サーバーサイドコードへのリンク(このコードは実行されません)
const __non_exec_code = async () => {
  // import("../../../server/biz/AuthService");
};

export class AuthService extends GeneratedBizBase{
  async classRoomLogin(user_id: number,member_id: number): Promise<Response<AuthUser>> {
    return super.restCall<Response<AuthUser>>('post', '/v1/AuthService/classRoomLogin', arguments);
  }
  async forceLogin(mail: string): Promise<Response<AuthUser>> {
    return super.restCall<Response<AuthUser>>('post', '/v1/AuthService/forceLogin', arguments);
  }
  async login(mail: string,password: string): Promise<Response<AuthUser>> {
    return super.restCall<Response<AuthUser>>('get', '/v1/AuthService/login', arguments);
  }
  async createUserApi(mail: string,password: string,create_name: string,auth_tags: string,belong_to: string): Promise<Response<AuthUser>> {
    return super.restCall<Response<AuthUser>>('post', '/v1/AuthService/createUserApi', arguments);
  }
  async oAuthLoginByUser(mail: string,oAuthUser: OAuthResultUser): Promise<Response<AuthUser>> {
    return super.restCall<Response<AuthUser>>('post', '/v1/AuthService/oAuthLoginByUser', arguments);
  }
  async oAuthLogin(mail: string,oAuthResult: OAuthResult): Promise<Response<AuthUser>> {
    return super.restCall<Response<AuthUser>>('post', '/v1/AuthService/oAuthLogin', arguments);
  }
  async changeAuthTag(user_id: number,newTag: string): Promise<Response<Users>> {
    return super.restCall<Response<Users>>('post', '/v1/AuthService/changeAuthTag', arguments);
  }
}
